export function updateScroll(pos = {top: 0}) {
  document.body.scrollTop = document.documentElement.scrollTop = pos.top;
}
